module.exports = __webpack_public_path__ + "img/member-invite-authority-x.09b12c11.svg";